<div class="d-flex my-1 product-item p-1 cursor-pointer">
  <div class="position-relative">
    <atx-image
      [imageUrl]="product.mainImageUrl"
      [maxWidth]="imageMaxSize"
      failedLoadIconSize="1x"
      fallbackImageUrl="static/images/placeholder-image.jpg"
    ></atx-image>
    @if (product.priceRanges[0]?.discount?.max > 0) {
    <atx-discount-label
      *atxCanShowByWsp
      class="badge-success"
      [discount]="product.priceRanges[0]?.discount"
    ></atx-discount-label>
    }
  </div>

  <div class="product-item__info flex-1">
    <div class="d-flex align-items-center">
      <span class="font-weight-bold mr-2">{{
        product
          | productTitle: { fields: idFields() }
          | productId: productIdAdditionalPrefixRexExp()
      }}</span>

      <atx-product-labels
        class="align-items-end"
        [productLabels]="product.labels | filterLabelsByName: 'discount'"
        [location]="labelsLocation"
        [shownLabelsLimit]="shownLabelsLimit()"
      ></atx-product-labels>
    </div>
    <atx-product-card-title
      [product]="product"
      [titleFields]="titleFields()"
    ></atx-product-card-title>
    @if(product.priceRanges?.[0]) {
    <atx-product-prices
      [prices]="product.priceRanges[0]"
      [showWholeSalePrices]="showWholeSalePrices()"
      [showMarkup]="showMarkupPrice()"
      [showWspdPrice]="showWspdPrice()"
    ></atx-product-prices>
    }
  </div>
</div>
